import { baseUrl } from '../../shared/utils';

/** Get the text TOTP seed for the current user */
async function getTotpSeedValue(): Promise<string> {
  const response = await fetch(`${baseUrl.authms}/totp/manualSetup`);
  const json = (await response.json()) as { secret: string };

  return json.secret;
}

export const api = {
  getTotpSeedValue,
};
